// Feature flag for the Auto Seating module. Default ON — finished modules ship
// visible on every device the host logs into (never tied to one browser).
// Emergency build-time kill-switch: REACT_APP_AUTO_SEATING='false'. Per-browser
// opt-out: localStorage 'auto_seating_enabled'==='0'. Mirrors event-program/programFlag.js.
export function isAutoSeatingEnabled() {
  try {
    const env = process.env.REACT_APP_AUTO_SEATING;
    if (env === 'true') return true;
    if (env === 'false') return false;                 // build-time kill-switch
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage.getItem('auto_seating_enabled') !== '0';
    }
  } catch (e) { /* ignore */ }
  return true;                                         // ON by default
}
